import { useEffect, useState } from "react";
import db from "./Backend";
import { collection, onSnapshot, orderBy, query } from "firebase/firestore";
import Testimonycontent from "./newComponent/TestimonyContent";

const Approvals = () => {
    const [testimonies,setTestimonies]=useState([]);
    const [yearTestified,setYeartestified]=useState("");

    useEffect(()=>{
      const currentDate = new Date();
      setYeartestified(currentDate.getFullYear().toString());
    },[yearTestified]);

    useEffect(()=>{
      const collectionref = collection(db,"testimonyReview");
      // const q = query(collectionref,where("year","==",yearTestified), orderBy("timestamp","desc"));
      const q = query(collectionref, orderBy("timestamp","desc"));
      try{
          const unsub = onSnapshot(q,(snapshot)=>{
               const getdata = [];
               snapshot.forEach((doc)=>{
                   getdata.push(doc.data());
               });
               setTestimonies(getdata);
          });
           return unsub;
       }catch(err){
           console.log(err);
       }
  },[yearTestified]);




    return (
        <div className="approvals">
          {testimonies && testimonies.map(data => (
              <Testimonycontent
                key={data.timestamp}
                username={data.username}
                user_unit={data.user_unit}
                user_chapter={data.user_chapter}
                year={data.year}
                dateSent={data.dateSent}
                timestamp={data.timestamp}
                testimony={data.testimony}
                displaypic={data.displaypic}
                senderID={data.senderID}
              />
          ))}

  
        </div>
      );
}
export default Approvals;